// extracted by mini-css-extract-plugin
module.exports = {"card":"TypeCard_card__3GtqA","content":"TypeCard_content__b5z9g"};